"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeImplementation = typeImplementation;

var _utils = require("../utils");

var _click = require("../click");

var _keyboard = require("../keyboard");

function typeImplementation(_x, _x2, _x3) {
  return _typeImplementation.apply(this, arguments);
}

function _typeImplementation() {
  _typeImplementation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element, text, _ref) {
    var delay, _ref$skipClick, skipClick, _ref$skipAutoClose, skipAutoClose, _ref$initialSelection, initialSelectionStart, _ref$initialSelection2, initialSelectionEnd, currentElement, value, _ref2, selectionStart, selectionEnd, _ref3, promise, releaseAllKeys;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delay = _ref.delay, _ref$skipClick = _ref.skipClick, skipClick = _ref$skipClick === void 0 ? false : _ref$skipClick, _ref$skipAutoClose = _ref.skipAutoClose, skipAutoClose = _ref$skipAutoClose === void 0 ? false : _ref$skipAutoClose, _ref$initialSelection = _ref.initialSelectionStart, initialSelectionStart = _ref$initialSelection === void 0 ? undefined : _ref$initialSelection, _ref$initialSelection2 = _ref.initialSelectionEnd, initialSelectionEnd = _ref$initialSelection2 === void 0 ? undefined : _ref$initialSelection2;

            if (!element.disabled) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (!skipClick) (0, _click.click)(element); // The focused element could change between each event, so get the currently active element each time

            currentElement = function currentElement() {
              return (0, _utils.getActiveElement)(element.ownerDocument);
            }; // by default, a new element has its selection start and end at 0
            // but most of the time when people call "type", they expect it to type
            // at the end of the current input value. So, if the selection start
            // and end are both the default of 0, then we'll go ahead and change
            // them to the length of the current value.
            // the only time it would make sense to pass the initialSelectionStart or
            // initialSelectionEnd is if you have an input with a value and want to
            // explicitly start typing with the cursor at 0. Not super common.


            value = (0, _utils.getValue)(currentElement());
            _ref2 = (0, _utils.getSelectionRange)(element), selectionStart = _ref2.selectionStart, selectionEnd = _ref2.selectionEnd;

            if (value != null && (selectionStart === null || selectionStart === 0) && (selectionEnd === null || selectionEnd === 0)) {
              (0, _utils.setSelectionRange)(currentElement(), initialSelectionStart != null ? initialSelectionStart : value.length, initialSelectionEnd != null ? initialSelectionEnd : value.length);
            }

            _ref3 = (0, _keyboard.keyboardImplementationWrapper)(text, {
              delay: delay,
              document: element.ownerDocument
            }), promise = _ref3.promise, releaseAllKeys = _ref3.releaseAllKeys;

            if (!(delay > 0)) {
              _context.next = 12;
              break;
            }

            _context.next = 12;
            return promise;

          case 12:
            if (!skipAutoClose) {
              releaseAllKeys();
            } // eslint-disable-next-line consistent-return -- we need to return the internal Promise so that it is catchable if we don't await


            return _context.abrupt("return", promise);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _typeImplementation.apply(this, arguments);
}